import configStore from 'store/configStore'
import { PostHog } from 'posthog-js'

export function initPostHogFeaturesFlags(postHog: PostHog) {
  configStore.setIsDynamicTts(!!postHog.isFeatureEnabled('dynamic_tts'))
  configStore.setIsDataCollection(!!postHog.isFeatureEnabled('data_collection'))
  configStore.setIsDataCapture(!!postHog.isFeatureEnabled('data_capture'))
}
